import * as React from 'react';
import QuantityPickerCart from 'src/component/Global/Cart/QuantityPicker'

const QuantityPicker = (props) => {
    return (
        <QuantityPickerCart {...props}/>
    )
}

export default QuantityPicker;